// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacySearchModelResponse {
    static getAttributeTypeMap() {
        return PharmacySearchModelResponse.attributeTypeMap;
    }
}
PharmacySearchModelResponse.discriminator = undefined;
PharmacySearchModelResponse.additionalProperties = false;
PharmacySearchModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PharmacySearchResponseModel"
    },
];
//# sourceMappingURL=pharmacySearchModelResponse.js.map